import { useMemo } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import type { RelayChatExtension } from '@inference.engine/agentic-react';
import { TAXONOMY_SCHEMA_CHANGED_PART } from '@inference.engine/taxonomy/web';
import { schemaChangedExtension } from '@/entities/taxonomy';
import { TAXONOMY_LIST_QUERY_KEYS } from '@/entities/taxonomy-list';

/**
 * Reads the schema again whenever its agent changes it, so the page follows the agent, and its
 * lists too: the agent creates, edits and publishes lists the schema's fields show.
 */
export function useSchemaAgentExtensions(taxonomyId: string): RelayChatExtension[] {
  const queryClient = useQueryClient();
  return useMemo(
    () => [
      schemaChangedExtension(queryClient, taxonomyId),
      {
        part: `data-${TAXONOMY_SCHEMA_CHANGED_PART}`,
        onPart: () => {
          void queryClient.invalidateQueries({ queryKey: TAXONOMY_LIST_QUERY_KEYS.all });
        },
      },
    ],
    [queryClient, taxonomyId],
  );
}
